import getDistanceInMiles from "./getDistanceInMiles";
import getAddressString from "./getAddressString";
import getLatLng from "./getLatLng";
export default function calculateDistance() {
  let locationObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const location = locationObj.attributes ? locationObj.attributes : locationObj;
  const latLng = getLatLng(location);
  const distance = getDistanceInMiles(origin, latLng) || '0 miles';
  const addressString = getAddressString(location);
  const distanceVal = distance.split(' ')[0];
  const name = location.name || '';
  return {
    displayName: addressString,
    distance,
    distanceVal: parseFloat(distanceVal.replace(/,/g, '')),
    name,
    ...location
  };
}
//# sourceMappingURL=calculateDistance.js.map